import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import DeliveryPartnerLedgerService from "../services/DeliveryPartnerLedgerService";

export const DeliveryPartnerLedgerContext = createContext(
	"DeliveryPartnerLedgerContext",
);

const DeliveryPartnerLedgerContextProvider = ({ children }) => {
	const [deliveryPartnerLedgerList, setDeliveryPartnerLedgerList] = useState(
		[],
	);
	const [
		loadingDeliveryPartnerLedgerList,
		setLoadingDeliveryPartnerLedgerList,
	] = useState(false);
	const [
		deliveryPartnerLedgerListErrorMsg,
		setDeliveryPartnerLedgerListErrorMsg,
	] = useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getDeliveryPartnerLedgerList = async (id, params) => {
		setLoadingDeliveryPartnerLedgerList(true);
		try {
			setDeliveryPartnerLedgerListErrorMsg("");
			const response =
				await DeliveryPartnerLedgerService.getDeliveryPartnerLedgerList(
					id,
					params,
				);
			setDeliveryPartnerLedgerList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setDeliveryPartnerLedgerListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingDeliveryPartnerLedgerList(false);
		}
	};

	return (
		<DeliveryPartnerLedgerContext.Provider
			value={{
				getDeliveryPartnerLedgerList,
				deliveryPartnerLedgerList,
				totalElements,
				loadingDeliveryPartnerLedgerList,
				deliveryPartnerLedgerListErrorMsg,
			}}
		>
			{children}
		</DeliveryPartnerLedgerContext.Provider>
	);
};

export default DeliveryPartnerLedgerContextProvider;
